import Vue from 'vue'
import Router from 'vue-router'

import i18next, { allowedLanguages, defaultLanguage } from '@/i18n'
import store from '@/store'

// Views
import I18nView from '@/views/I18nView'

Vue.use(Router)
const defaultPages = [
    {
        path: '',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Home')
    },
    {
        path: 'success',
        name: 'success',
        component: () => import(/* webpackChunkName: "success" */ '@/views/Thank-You')
    }
]

const routes = [
    {
        path: '/',
        name: 'root',
        redirect: {
            name: 'home',
            params: {
                locale: (store.state.app.language) ? store.state.app.language : defaultLanguage
            }
        }
    },
    {
        path: '/:locale(' + allowedLanguages.join('|') + ')',
        component: I18nView,
        children: defaultPages
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new Router({
    mode: 'history',
    base: (process.env.BASE_URL) ? process.env.BASE_URL : '/',
    linkActiveClass: 'active',
    linkExactActiveClass: 'active-exact',
    routes
})

router.beforeEach((to, from, next) => {
    let newLanguage = to.params.locale

    if (newLanguage) {
        if (newLanguage !== i18next.language) {
            i18next.changeLanguage(newLanguage)
        }
        if (newLanguage !== store.state.app.language) {
            store.dispatch('app/changeLanguage', newLanguage)
        }
    }

    next()
})

router.afterEach((to, from) => {
    if (from.name !== null && to.name !== null) {
        store.dispatch('app/set', {
            activeRoute: {
                name: to.name,
                params: to.params
            }
        })
    }
})

export default router
